export default __webpack_public_path__ + "static/media/330_business08-jp-web.2617a23e.png";